import type { QueryParams } from '~/types/api'
import type { Rendering, RenderingPagedResult } from '~/types/api'

export function createRenderingsRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'renderings'

  async function getAll(params?: QueryParams) {
    return get<RenderingPagedResult>([DOMAIN], { params })
  }

  async function getByNid(nid: number) {
    return get<Rendering>([DOMAIN, nid.toString()]) // TODO: langPath: [DOMAIN]
  }

  return {
    getAll,
    getByNid,
  }
}
